import ModelYearActions from 'commons-vehicle/ModelYear/actions/modelYearActions.js';
import ModelYearActionsTypes from 'commons-vehicle/ModelYear/actions/modelYearActionTypes.js';

import en from 'commons-vehicle/ModelYear/i18n/en.json';
import fr from 'commons-vehicle/ModelYear/i18n/fr.json';

import CabSizeModel from 'commons-vehicle/ModelYear/models/CabSizeModel.js';
import BoxSizeModel from 'commons-vehicle/ModelYear/models/BoxSizeModel.js';
import ColourModel from 'commons-vehicle/ModelYear/models/ColourModel.js';
import DrivePowerTrainModel from 'commons-vehicle/ModelYear/models/DrivePowerTrainModel.js';
import DriveTrainModel from 'commons-vehicle/ModelYear/models/DriveTrainModel.js';
import EngineModel from 'commons-vehicle/ModelYear/models/EngineModel.js';
import FeatureIconModel from 'commons-vehicle/ModelYear/models/FeatureIconModel.js';
import FeatureModel from 'commons-vehicle/ModelYear/models/FeatureModel.js';
import ModelTrimConfigurationModel from 'commons-vehicle/ModelYear/models/ModelTrimConfigurationModel.js';
import ModelTrimModel from 'commons-vehicle/ModelYear/models/ModelTrimModel.js';
import ModelYearModel from 'commons-vehicle/ModelYear/models/ModelYearModel.js';
import OptionModel from 'commons-vehicle/ModelYear/models/OptionModel.js';
import OptionsPackageModel from 'commons-vehicle/ModelYear/models/OptionsPackageModel.js';
import TransmissionModel from 'commons-vehicle/ModelYear/models/TransmissionModel.js';
import YearModel from 'commons-vehicle/ModelYear/models/YearModel.js';
import ModelYearReducer from 'commons-vehicle/ModelYear/reducers/modelYearReducer.js';

import ColourService from 'commons-vehicle/ModelYear/services/ColourService/ColourService.js';
import DataUtilitiesService from 'commons-vehicle/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js';
import DrivePowerTrainService from 'commons-vehicle/ModelYear/services/DrivePowerTrainService/DrivePowerTrainService.js';
import DriveTrainService from 'commons-vehicle/ModelYear/services/DriveTrainService/DriveTrainService.js';
import EngineService from 'commons-vehicle/ModelYear/services/EngineService/EngineService.js';
import ModelTrimConfigurationService from 'commons-vehicle/ModelYear/services/ModelTrimConfigurationService/ModelTrimConfigurationService.js';
import ModelTrimItemsService from 'commons-vehicle/ModelYear/services/ModelTrimItemsService/ModelTrimItemsService.js';
import ModelTrimService from 'commons-vehicle/ModelYear/services/ModelTrimService/ModelTrimService.js';
import ModelYearService from 'commons-vehicle/ModelYear/services/ModelYearService/ModelYearService.js';
import OptionService from 'commons-vehicle/ModelYear/services/OptionService/OptionService.js';
import OptionsPackageService from 'commons-vehicle/ModelYear/services/OptionsPackageService/OptionsPackageService.js';
import TransmissionService from 'commons-vehicle/ModelYear/services/TransmissionService/TransmissionService.js';
import YearService from 'commons-vehicle/ModelYear/services/YearService/YearService.js';

import EXTERIOR_COLOUR_STATUSES from 'commons-vehicle/ModelYear/constants/exteriorColourStatuses.js';

const Translations = {
    en,
    fr,
};

export {
    ModelYearActions,
    ModelYearActionsTypes,
    Translations,
    CabSizeModel,
    BoxSizeModel,
    ColourModel,
    DrivePowerTrainModel,
    DriveTrainModel,
    EngineModel,
    FeatureIconModel,
    FeatureModel,
    ModelTrimConfigurationModel,
    ModelTrimModel,
    ModelYearModel,
    OptionModel,
    OptionsPackageModel,
    TransmissionModel,
    YearModel,
    ModelYearReducer,
    ColourService,
    DataUtilitiesService,
    DrivePowerTrainService,
    DriveTrainService,
    EngineService,
    ModelTrimConfigurationService,
    ModelTrimItemsService,
    ModelTrimService,
    ModelYearService,
    OptionService,
    OptionsPackageService,
    TransmissionService,
    YearService,
    EXTERIOR_COLOUR_STATUSES,
};

export default {
    ModelYearActions,
    ModelYearActionsTypes,

    Translations,

    CabSizeModel,
    BoxSizeModel,
    ColourModel,
    DrivePowerTrainModel,
    DriveTrainModel,
    EngineModel,
    FeatureIconModel,
    FeatureModel,
    ModelTrimConfigurationModel,
    ModelTrimModel,
    ModelYearModel,
    OptionModel,
    OptionsPackageModel,
    TransmissionModel,
    YearModel,
    ModelYearReducer,

    ColourService,
    DataUtilitiesService,
    DrivePowerTrainService,
    DriveTrainService,
    EngineService,
    ModelTrimConfigurationService,
    ModelTrimItemsService,
    ModelTrimService,
    ModelYearService,
    OptionService,
    OptionsPackageService,
    TransmissionService,
    YearService,

    EXTERIOR_COLOUR_STATUSES,
};



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/ModelYear/index.js